const filtype = {
    pdf: 'pdf',
    xlsx: 'xlsx'
}

export default filtype
